import styled from 'styled-components';

import { colors, media, type } from 'styles';

export const MagicLinkGeneratedWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CheckmarkIcon = styled.img`
  width: 80px;
  height: 80px;

  ${media.min.baseline`
    width: 100px;
    height: 100px;
  `}

  ${media.min.desktop`
    width: 125px;
    height: 125px;
  `}
`;

export const HeaderText = styled.h1`
  font-weight: ${type.weight.bold};
  font-size: 2.2rem;
  margin-top: 28px;
  margin-bottom: 0;

  ${media.min.baseline`
    font-size: 2.4rem;
    margin-top: 32px;
  `}

  ${media.min.desktop`
    font-size: 2.8rem;
    margin-top: 40px;
  `}
`;

export const EmailText = styled.span`
  font-weight: ${type.weight.bold};
`;

export const MessageText = styled.p`
  width: 100%;
  font-size: 1.4rem;
  text-align: center;
  margin-top: 18px;
  margin-bottom: 0;

  ${media.min.baseline`
    font-size: 1.8rem;
    margin-top: 22px;
  `}
`;

export const CTAWrapper = styled.div`
  margin-top: 14px;
`;

export const LegalText = styled.div`
  text-align: center;
  font-size: ${type.scale.centi.size};
  font-weight: ${type.weight.regular};
  color: ${colors.ridge.base};
  margin-top: 14px;
  line-height: normal;
  padding: 0 28px;
`;
